import SeoHead from './SeoHead';
import { Breadcrumbs } from './ComponentLibrary';
import { pageMeta } from '../seoUtils';

function AboutPage() {
  const seo = pageMeta({
    title: 'About Us',
    description:
      "Learn about Naija Nest Properties, Nigeria's trusted marketplace for renting and short-let stays, with sales and land listings also available.",
    path: '/about',
  });
  return (
    <div className="static-page about-page">
      <SeoHead title={seo.fullTitle} description={seo.desc} url={seo.url} image={seo.img} />
      <Breadcrumbs
        items={[{ label: 'Home', href: '/' }, { label: 'About Us', current: true }]}
      />
      <section className="section">
        <header className="about-page__intro">
          <h1>About NaijaNest</h1>
          <p className="static-page__lead">
            NaijaNest connects renters and short-let guests with hosts and agents, while also
            supporting buyers and land seekers, through moderated listings across all 36 states
            and the FCT.
          </p>
        </header>
        <h2>Our Mission</h2>
        <p>
          We believe finding a home in Nigeria shouldn't be stressful, risky, or opaque. NaijaNest
          was built to bring transparency, trust, and simplicity to the Nigerian property market.
        </p>
        <h2 id="how-it-works">How It Works</h2>
        <div className="static-page__steps">
          <div className="static-page__step">
            <span className="static-page__step-number">1</span>
            <h3>Search</h3>
            <p>Browse properties by state, area, type, and budget.</p>
          </div>
          <div className="static-page__step">
            <span className="static-page__step-number">2</span>
            <h3>Verify</h3>
            <p>Review details, photos, and our due diligence checklist.</p>
          </div>
          <div className="static-page__step">
            <span className="static-page__step-number">3</span>
            <h3>Connect</h3>
            <p>Contact the agent or landlord directly via WhatsApp.</p>
          </div>
        </div>
        <h2>Why NaijaNest?</h2>
        <ul className="static-page__features">
          <li>
            <strong>Nigeria-Focused</strong>: Built for the Nigerian market with local insights.
          </li>
          <li>
            <strong>Due Diligence Tools</strong>: Spot red flags before committing.
          </li>
          <li>
            <strong>Free to Use</strong>: Searching and browsing is completely free.
          </li>
          <li>
            <strong>Agent Dashboard</strong>: Agents can list and manage properties easily.
          </li>
        </ul>
        <h2 id="careers">Careers</h2>
        <p>
          Interested in joining us? See our <a href="/careers">open roles</a>.
        </p>
        <h2>Company Information</h2>
        <p>
          NaijaNest is operated by NaijaNest Prime Hub, a company registered in Nigeria (RC
          9619830).
        </p>
      </section>
    </div>
  );
}
export default AboutPage;
